import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { beforeItems, afterItems } from '../data/beforeAfter';
import { SectionHeading } from './SectionHeading';
import { SectionCta } from './SectionCta';
export function BeforeAfter() {
  return <section className="w-full bg-white px-5 py-16 sm:py-24" aria-label="Before vs. with the pathway" data-id="element-41" data-mp="3ohubjgyo7c73">
      <div className="mx-auto max-w-6xl" data-id="element-42" data-mp="3sjfv1l5pmoq9">
        <SectionHeading eyebrow="Before vs. with the pathway" title="From Starting at Zero to Following a Repeatable Process" data-id="element-43" data-mp="3epokqak5n0th" />

        <div className="mt-12 grid gap-6 lg:grid-cols-2" data-id="element-44" data-mp="3ji9bt4boeztb">
          <div className="rounded-3xl bg-dangerSoft p-6 sm:p-8" data-id="element-45" data-mp="34sagraff44i2">
            <div className="flex items-center gap-3" data-id="element-46" data-mp="34ppe4j7apkj9">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-danger text-white" data-id="element-47" data-mp="39rwudkz5rmre">
                <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-48" data-mp="2vsey6kjj9780" />
              </span>
              <h3 className="font-heading text-2xl font-bold text-danger" data-id="element-49" data-mp="30p5f1a35w6uh">Before</h3>
            </div>
            <ul className="mt-6 divide-y divide-danger/15" data-id="element-50" data-mp="x3irisj8h5ni">
              {beforeItems.map(item => <li key={item} className="flex gap-3 py-3.5 leading-relaxed text-ink/80" data-id="element-51" data-mp="t26y0bx8o0a1">
                  <XIcon className="mt-1 h-4 w-4 shrink-0 text-danger" aria-hidden="true" data-id="element-52" data-mp="171or33hkhzp7" />
                  <span data-id="element-53" data-mp="123dj6yau1z9m">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl bg-okSoft p-6 ring-2 ring-ok sm:p-8" data-id="element-54" data-mp="ef40w6ctvtn8">
            <div className="flex items-center gap-3" data-id="element-55" data-mp="9f96vtxranxy">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-ok text-white" data-id="element-56" data-mp="9gsphr6vxb2w">
                <CheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-57" data-mp="o5yn5aq2qt8o" />
              </span>
              <h3 className="font-heading text-2xl font-bold leading-tight text-ok" data-id="element-58" data-mp="jbufep8zih6j">With the Pathway™</h3>
            </div>
            <ul className="mt-6 divide-y divide-ok/15" data-id="element-59" data-mp="3rqm9k3gunjqk">
              {afterItems.map(item => <li key={item} className="flex gap-3 py-3.5 font-medium leading-relaxed text-ink" data-id="element-60" data-mp="3ms1gqp3xg2c5">
                  <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-ok" aria-hidden="true" data-id="element-61" data-mp="1qowq3bon5q36" />
                  <span data-id="element-62" data-mp="1vnhhqmptv1g0">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-10 max-w-2xl text-center font-heading text-xl font-medium leading-snug text-ink sm:text-2xl" data-id="element-63" data-mp="24hw8blft5yef">
          The difference isn’t having all the answers. It’s knowing how to organize the information and identify what you
          still need to understand.
        </p>
        <SectionCta label="I want the complete pathway" data-id="element-64" data-mp="1gsjsi2pz6s35" />
      </div>
    </section>;
}